import { render, staticRenderFns } from "./modalEnviarPedido.vue?vue&type=template&id=14e1ba76"
import script from "./modalEnviarPedido.vue?vue&type=script&lang=js"
export * from "./modalEnviarPedido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports